/**
 * Where this application's backend lives, and how to reach its realtime channel.
 *
 * The suite points `NEXT_PUBLIC_API_URL` at the hub's one API origin. Two shapes exist
 * there: `/api/vault`, where the drive data is *pooled* (the hub's own routes, the hub's
 * session token, the hub's socket.io), and `/api/suite/sak`, where this application's own
 * Express answers anything not pooled yet. `src/lib/api.ts` is what keeps both honest:
 * REST composes onto the base as-is, while socket.io appends its path to the *origin* and
 * would silently drop a mount — so the URL and the path are stated separately.
 */
const FALLBACK = "http://localhost:4000";

export const API_URL = (process.env.NEXT_PUBLIC_API_URL || FALLBACK).replace(/\/+$/, "");

function parse(raw: string): URL | null {
  try {
    return new URL(raw);
  } catch {
    return null;
  }
}

const base = parse(API_URL);

/** Origin socket.io dials, and the path it dials. The env pair is what the suite injects:
 *  a pooled drive uses the hub's own `/socket.io`, whose handshake verifies the very token
 *  the vault routes issue. The fallbacks keep a standalone run pointed at its own backend. */
export const SOCKET_URL = process.env.NEXT_PUBLIC_SOCKET_URL ?? (base ? base.origin : FALLBACK);
export const SOCKET_PATH =
  process.env.NEXT_PUBLIC_SOCKET_PATH ??
  (base && base.pathname !== "/" ? `${base.pathname.replace(/\/+$/, "")}/socket.io` : "/socket.io");
